/*=========================================================================================
  File Name: moduleTitleActions.js
  Description: Title Module Actions
==========================================================================================*/

import titleGql from "@/http/requests/card/title_gql.js";
import roleGql from "@/http/requests/link/role_gql.js";

export default {
	fetchTitles({ commit }, payload) {
		return new Promise((resolve, reject) => {
			titleGql
				.fetchTitles(payload)
				.then(response => {
					commit("SET_TITLES", response.titles);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_TITLES", false);
					reject(error);
				});
		});
	},
	toggleTitleCategorySideBar({ commit }, payload) {
		commit("SET_TITLE_CATEGORY_SIDEBAR_STATUS", payload.status);
	},
	updateTitle({ commit }, payload) {
		return new Promise((resolve, reject) => {
			titleGql
				.updateTitle(payload)
				.then(response => {
					commit("UPDATE_TITLE", response.title);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_TITLES", false);
					reject(error);
				});
		});
	},

	addTitle({ commit }, payload) {
		return new Promise((resolve, reject) => {
			titleGql
				.addTitle(payload)
				.then(response => {
					commit("ADD_NEW_TITLE", response.title);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_TITLES", false);
					reject(error);
				});
		});
	},

	deleteTitle({ commit }, payload) {
		return new Promise((resolve, reject) => {
			titleGql
				.deleteTitle(payload)
				.then(response => {
					commit("DELETE_TITLE", response.title);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_TITLES", false);
					reject(error);
				});
		});
	},
	fetchRoles({ commit }, payload) {
		return new Promise((resolve, reject) => {
			roleGql
				.fetchRoles(payload)
				.then(response => {
					commit("SET_ROLES", response.roles.data);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	bulkUpdateTitles({ commit }, payload) {
		return new Promise((resolve, reject) => {
			titleGql
				.bulkUpdateTitles(payload)
				.then(response => {
					commit("NOTHING");
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
